export default __webpack_public_path__ + "static/media/checkmarkIcon-black.5d4a770d.svg";